import React from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";

function TermesConditionsPage() {
  return (
    <div className="page-content auction-page">
      <Container fluid>
        <Breadcrumbs title="Termes & Conditions" breadcrumbItems={[{ title: "Férailleurs", link: "#" }, { title: "Termes & Conditions", link: "#" }]} />
        <Row>
          <Col lg={9}>
            <Card>
              <CardBody>
                <h4 className="mb-3">Conditions de participation aux enchères</h4>
                <p className="text-muted">
                  La participation implique l’acceptation des règles de vente, des délais de paiement et des modalités
                  d’enlèvement communiquées pour chaque lot.
                </p>
                <div className="terms-list">
                  <div><strong>Eligibilité</strong><span>Seuls les férailleurs actifs et rattachés à un groupe ciblé peuvent visualiser les enchères concernées.</span></div>
                  <div><strong>Offres</strong><span>Les offres doivent respecter le pas minimal et restent engageantes jusqu’à la clôture.</span></div>
                  <div><strong>Paiement</strong><span>Le paiement doit être réalisé selon les modalités précisées par l’administrateur.</span></div>
                  <div><strong>Enlèvement</strong><span>L’acheteur est responsable de l’enlèvement du véhicule après confirmation de l’attribution.</span></div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default TermesConditionsPage;
